import { map as _map } from 'lodash-es';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import PanToolIcon from '@mui/icons-material/PanTool';
import SelectField from '../forms/select-field';
import { eventRegroups } from '../../utils/events';
import type { EventFormValues } from './form';

const useStyles = makeStyles()((theme) => ({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
}));

const EventFormRegroups = (props) => {
  const { classes } = useStyles();
  const { values: { eventType } } = useFormikContext<EventFormValues>();

  const options = useMemo(() => _map(eventRegroups, ({ name }, value) => ({
    label: name,
    value,
  })), []);

  if (eventType !== 'RIDE') {
    return null;
  }

  return (
    <SelectField
      name="regroup"
      label={(
        <span className={classes.label}>
          <PanToolIcon className={classes.icon} />
          Regroup (optional)
        </span>
      )}
      options={options}
      placeholder="Choose One"
      {...props}
    />
  );
};

export default EventFormRegroups;
